import pick from 'lodash/pick'
import { createReducer } from '@fakundo/redux-entities'
import { ME_REPLACE } from 'actions/me'
import * as entityNames from 'constants/entityNames'

const { TIMEZONES, CURRENCIES, PLANS } = entityNames
const staticEntities = [TIMEZONES, CURRENCIES, PLANS]

const createCustomReducer = initialState => (state, action) => {
  switch (action.type) {
    case ME_REPLACE: {
      return {
        ...initialState,
        ...pick(state, staticEntities) // Do not reset static entities
      }
    }

    default:
      return state
  }
}

export default createReducer(entityNames, createCustomReducer)
